import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { StarterComponent } from "./starter.component";
import { AdminOverviewComponent } from './admin-overview/admin-overview.component';
import { OverallInsightsComponent } from './overall-insights/overall-insights.component';
import { NetworkOverviewComponent } from './networkOverview/network-overview.component';
import { AccessGuard } from 'src/app/core/guards/access.guard';
import { ReferEarnComponent } from "./refer-earn.component";
import { ReferStaticsComponent } from './refer-statics/refer-statics.component';
import { ReferStaticsAdminComponent } from './refer-statics-admin/refer-statics-admin.component';

const routes: Routes = [
  {
    path: "",
    component: StarterComponent,
  },
  {
    path: "overview",
    canActivate: [AccessGuard],
    data: { permissionName: "Dashboard", access: 1 },
    component:AdminOverviewComponent,
  },
  {
    path: "overall-insights",
    component: OverallInsightsComponent,
  },
  {
    path:'network-overview/:id',
    component:NetworkOverviewComponent,
  },
  {
    path:'refer-earn',
    component:ReferEarnComponent,
  },
  {
    path: "refer-stats",
    component: ReferStaticsComponent,
  },
  {
    path: "refer-statics",
    component: ReferStaticsAdminComponent,
  }
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class StarterRoutingModule { }
